<template>
  <div id="box" v-loading="loading">
    <el-scrollbar style="height: 100%;">
      <el-form ref="registeInfo" class="registeInfo" :rules="baseRules" size="medium" line-height="3px;" :model="registeInfo" label-width="30%">
        <el-collapse style="width:100%;margin-left:3%;" accordion>
          <el-collapse-item title="门店信息">
          <el-form-item label="公司名称" prop="shopName">
          <el-input v-model="registeInfo.shopName" placeholder="请输入营业执照全称"></el-input>
        </el-form-item>
        <el-form-item label="门店简称" prop="shopShortName">
          <el-input v-model="registeInfo.shopShortName" placeholder="请输入门店简称:XX大药房(XX路店)"></el-input>
        </el-form-item>
        <el-form-item label="行政区划" prop="provincesCity">
          <el-cascader
              v-model="registeInfo.provincesCity"
              :options="areaOptions"
              :props="cascaderProps"
              style="width: 100%;"
              @change="handleAreaChange"
              clearable
            />
        </el-form-item>
        <el-form-item label="法人姓名" prop="legalName">
          <el-input v-model="registeInfo.legalName" placeholder="请输入法人姓名"></el-input>
        </el-form-item>
        <el-form-item label="营执地址" prop="shopAddress">
          <el-input v-model="registeInfo.shopAddress" placeholder="请输入营业执照完整地址"></el-input>
        </el-form-item>
        <el-form-item label="税号" prop="shopTax">
          <el-input v-model="registeInfo.shopTax" placeholder="请输入税号"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="shopExecutor">
          <el-input v-model="registeInfo.shopExecutor" placeholder="门店负责人"></el-input>
        </el-form-item>
        <el-form-item label="负责人手机号" prop="shopPhone">
          <el-input v-model="registeInfo.shopPhone" placeholder="负责人电话"></el-input>
        </el-form-item>
        <el-form-item label="客服电话" prop="customerServerPhone">
          <el-input v-model="registeInfo.customerServerPhone" placeholder="请输入客服电话"></el-input>
        </el-form-item>
        <el-form-item label="门店营业时间" prop="bussinessTime">
          <el-input v-model="registeInfo.bussinessTime" placeholder="请输入营业时间（中间不要有空格）"></el-input>
        </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="财务信息">
            <el-form-item label="账户名" prop="payName">
          <el-input v-model="registeInfo.payName" placeholder="请输入账户名"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="payBank">
          <el-input v-model="registeInfo.payBank" placeholder="请输入XX银行XX支行"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="payNo">
          <el-input v-model="registeInfo.payNo" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="财务联系人" prop="financePersonName">
          <el-input v-model="registeInfo.financePersonName" placeholder="请输入财务联系人"></el-input>
        </el-form-item>
        <el-form-item label="财务电话" prop="financePersonPhone">
          <el-input v-model="registeInfo.financePersonPhone" placeholder="请输入财务电话"></el-input>
        </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="药师信息">
            <el-form-item label="药师姓名" prop="chemistName">
          <el-input v-model="registeInfo.chemistName" placeholder="请输入药师姓名"></el-input>
        </el-form-item>
        <el-form-item label="药师身份证" prop="chemistID">
          <el-input v-model="registeInfo.chemistID" placeholder="请输入药师身份证号"></el-input>
        </el-form-item>
        <el-form-item label="药师手机号" prop="chemistPhone">
          <el-input v-model="registeInfo.chemistPhone" placeholder="请输入药师手机号"></el-input>
        </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="系统信息">
          <el-form-item label="系统类型">
            <el-select v-model="registeInfo.erpType" style="width: 100%;">
              <el-option label="网页版" value="网页版"></el-option>
              <el-option label="客户端版" value="客户端版"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="软件品牌">
          <el-input v-model="registeInfo.erpCompany" placeholder="请输入软件品牌"></el-input>
        </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="邀请人信息">
            <el-form-item label="邀请码" prop="inviteeAccount">
              <el-input v-model="registeInfo.inviteeAccount" placeholder="请输入邀请码,没有可不填"></el-input>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <el-button type="success" class="btnNext" @click="handleSubmit">下一步</el-button>
    </el-scrollbar>
  </div>
</template>

<script type="es6">
import weui from 'weui.js'
import $ from 'jquery'
import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import {$defalutIcon, choosePic} from '@/commons/wechat'
export default {
    data () {
      const validated = function (rule, value, callback) {
        if (value === '') {
          callback(new Error('请不要输入空号码!'))
        } else if (!/^1\d{10}$/.test(value)) {
          callback(new Error('请输入正确格式的手机号码!'))
        } else {
          callback()
        }
      }
      const validates = function (rule, value, callback) {
        if (value === '') {
          callback(new Error('请选择行政区划!'))
        } else {
          callback()
        }
      }
      return {
        cascaderProps: {
          value: "value",
          label: "label",
          expandTrigger: "click",
          checkStrictly: false,
          emitPath: true,
          lazy: true,
          lazyLoad: this.lazyLoadArea,
          isLeaf: (node, { level }) => {
            return level >= 2
          }
        },
        areaOptions: [],
        registeInfo: {
          id: '',
          shopName: '',
          shopShortName: '',
          provincesCity: [],
          shopAddress: '',
          shopTax: '',
          legalName: '',
          shopExecutor: '',
          shopPhone: '',
          customerServerPhone: '',
          bussinessTime: '',
          payName: '',
          payBank: '',
          payNo: '',
          financePersonName: '',
          financePersonPhone: '',
          erpType: '',
          erpCompany: '',
          erpServerId: '',
          wechatNo: '',
          salesmanPhone: '',
          buildStep: 0,
          workFlag: '',
          salesManId: '',
          bossId: '',
          chainId: '',
          chemistName: '',
          chemistID: '',
          chemistPhone: ''
        },
        registeInfo2: {
          erpServerId: ''
        },
        registeInfo3: {
          erpPicture: $defalutIcon
        },
        bussinessTime: '',
        baseRules: {
          shopName: [{required: true, message: '请输入公司名称', trigger: 'blur'}],
          shopShortName: [{required: true, message: '请输入门店名称', trigger: 'blur'}],
          shopExecutor: [{required: true, message: '请输入负责人', trigger: 'blur'}],
          shopAddress: [{required: true, message: '请输入营业执照地址', trigger: 'blur'}],
          legalName: [{required: true, message: '请输入法人姓名', trigger: 'blur'}],
          provincesCity: [{required: true, validator: validates, trigger: 'blur'}],
          shopTax: [{required: true, message: '请输入税号', trigger: 'blur'}],
          shopPhone: [{required: true, validator: validated, trigger: 'blur'}],
          bussinessTime: [{required: true, message: '请输入营业时间', trigger: 'blur'}],
          customerServerPhone: [{required: true, message: '请输入客服电话', trigger: 'blur'}],
          payName: [{required: true, message: '请输入对公账户名', trigger: 'blur'}],
          payBank: [{required: true, message: '请输入对公户行', trigger: 'blur'}],
          payNo: [{required: true, message: '请输入对公账户', trigger: 'blur'}],
          financePersonName: [{required: true, message: '请输入财务联系人', trigger: 'blur'}],
          financePersonPhone: [{required: true, message: '请输入财务联系电话', trigger: 'blur'}],
          chemistName: [{required: true, message: '请输入财务联系人药师姓名', trigger: 'blur'}],
          chemistID: [{required: true, message: '请输入财务联系人药师身份证号', trigger: 'blur'}],
          chemistPhone: [{required: true, message: '请输入药师联系电话', trigger: 'blur'}]
        },
        loading: false
      }
    },
    methods: {
      lazyLoadArea(node, resolve) {
        const id = node.value || 0
        const level = node.level
        this.$axios({
          method: 'get',
          url: '/v1/wShopRegister/china/address?parent='+id
        }).then((res) => {
          let arr = res.data.data;
          const processedArr = arr.map(item => {
            if (level === 2) { 
              const { children, ...rest } = item;
              return { ...rest, leaf: true }; 
            } else {
              return item;
            }
          });

          resolve(processedArr);
        })
      },
      handleAreaChange(codes) {
        this.registeInfo.provincesCity = codes
      },
      handleSubmit() {
        // 1. 定义所有必填字段名（按需增删，一目了然）
        const requiredFields = [
          'shopName', 'shopShortName', 'legalName', 'shopAddress', 
          'shopTax', 'shopExecutor', 'customerServerPhone', 'payName', 
          'payBank', 'payNo', 'financePersonName', 'financePersonPhone', 
          'chemistID', 'chemistPhone', 'chemistName', 'bussinessTime'
        ];

        // 2. 通用必填项检查函数（覆盖空字符串/undefined/null）
        const hasEmptyField = requiredFields.some(field => {
          // 空值判断：空字符串、undefined、null 都算未填写
          return !this.registeInfo[field] || this.registeInfo[field].toString().trim() === '';
        });

        // 3. 检查必填项
        if (hasEmptyField) {
          this.loading = false;
          this.$message.error('表单中有必填项没有填写，请检查！(带有红色星号的为必填)');
          return; // 终止后续逻辑
        }

        // 4. 原有业务逻辑（保持不变）
        console.log('==', this.registeInfo.provincesCity);
        this.registeInfo.provincesCity = this.registeInfo.provincesCity.join(',');
        this.registeInfo.bussinessTime = this.registeInfo.bussinessTime.toString();
        this.registeInfo.erpServerId = this.registeInfo2.erpServerId;

        this.$refs.registeInfo.validate((valid) => {
          if (valid) {
            this.$axios({
              method: 'post',
              url: '/v1/wShopRegister/saveShopInfo',
              data: this.registeInfo
            }).then((response) => {
              this.loading = false;
              if (response.data.code === 200) {
                this.$emit('change-step', 2, response.data.data.id);
              } else {
                this.$message.error(response.data.msg);
                this.loading = false;
              }
            }).catch((error) => {
              this.loading = false;
            });
          }
        });
      },
      // handleSubmit () {
      //  if(this.registeInfo.shopName !== '' && this.registeInfo.shopShortName !== '' && this.registeInfo.legalName !== '' && this.registeInfo.shopAddress !== '' && this.registeInfo.shopTax !== '' && this.registeInfo.shopExecutor !== '' && this.registeInfo.customerServerPhone !== '' && this.registeInfo.payName !== '' && this.registeInfo.payBank !== '' && this.registeInfo.payNo !== '' && this.registeInfo.financePersonName !== '' && this.registeInfo.financePersonPhone !== '' && this.registeInfo.chemistID !== '' && this.registeInfo.chemistPhone !== '' && this.registeInfo.chemistName !== '' && this.registeInfo.bussinessTime !== '') {
      //   console.log('==', this.registeInfo.provincesCity)
      //   this.registeInfo.provincesCity = this.registeInfo.provincesCity.join(',');
      //   this.registeInfo.bussinessTime = this.registeInfo.bussinessTime.toString();
      //   this.registeInfo.erpServerId = this.registeInfo2.erpServerId;
      //  // 这里加入tenantId
      //   this.registeInfo.tenantId = 1; 
        
      //   this.$refs.registeInfo.validate((valid) => {
      //     if (valid) {
      //       this.$axios({
      //         method: 'post',
      //         url: '/v1/wShopRegister/saveShopInfo',
      //         data: this.registeInfo
      //       }).then((response) => {
      //         this.loading = false
      //         if (response.data.code === 200) {
      //           this.$emit('change-step', 2, response.data.data.id)
      //         } else {
      //           this.$message.error(response.data.msg)
      //           this.loading = false
      //         }
      //       }).catch((error) => {
      //         this.$message.error(error.data.msg === '' ? '保存失败' : error.data.msg);
      //         this.loading = false;
      //       })
      //     }
      //   })
      //  } else {
      //   this.loading = false
      //    this.$message.error('表单中有必填项没有填写，请检查！(带有红色星号的为必填)')
      //  }
      // },
      choseFile (picUrl, serverId) {
        this.$weChat.choosePic(this, picUrl, serverId)
      },
      getBaseInfo () {
        console.log('hello', this.registeInfo)
        this.$axios({
          method: 'get',
          url: '/v1/wShopRegister/getShopInfo?id='+this.registeInfo.id,
        }).then((response) => {
          if (response.data.code === 200) {
            console.log('基础信息获取', response.data.data)
            if (response.data.data !== null) {
              this.registeInfo = response.data.data
              this.registeInfo.bussinessTime = response.data.data.bussinessTime.split(",")
              this.registeInfo.provincesCity = response.data.data.provincesCity.split(",")
              this.registeInfo.buildStep = 0
              this.registeInfo3.erpPicture = response.data.data.erpPicture
            }
          }
        }).catch((error) => {
          console.log('保存失败', error)
        })
      },
    },
    mounted () {
      let url = location.href.split("#")[0]; // 这里【url参数一定是去参的动态的当前页网址】
      console.log("url")
      this.$axios({
        method: 'post',
        url: '/v1/getJssdkSign',
        data: {url:url}
      }).then((response) => {
        if(response.data.code === 200){
          this.$weChat.getJssdkSign(response.data)
        } else {
          console.log("baseInfo微信签名验证失败")
        }
      }).catch((error) => {
        console.log('baseInfo微信签名验证失败',error)
      })

      let user = this.$storage.fetchStorage("user")
      if (user != null) {
        if (user.userFlag === 'salesman') {
          this.registeInfo.salesManId = user.id
        } else if (user.userFlag === 'boss') {
          this.registeInfo.bossId = user.id
        } else if (user.userFlag === 'chain') {
          this.registeInfo.chainId = user.id
        }
      }
      let shopId = this.$route.params.id;
      console.log("shop id",shopId)
      this.registeInfo.id = shopId
      this.getBaseInfo()
    },
    components: {
      provinceAndCityData,
      regionData,
      provinceAndCityDataPlus,
      regionDataPlus,
      CodeToText,
      TextToCode
    }
  }
</script>

<style>
  @import url("https://cdn.bootcss.com/weui/1.1.3/style/weui.min.css");
  @import url("https://cdn.bootcss.com/jquery-weui/1.2.1/css/jquery-weui.min.css");
#box{
  height: 100%;
  /* overflow-y: scroll; */
}
.registeInfo{
  margin-right: 23px;
  margin-top: 20px;
}
.btnNext{
  width: 50%;
  margin-bottom: 20px;
  margin-top: 20px;
}
.imgDemo{
      width: 60px;
      height: 60px;
      margin-bottom: 20px;
      float: left;
    }
</style>



// WEBPACK FOOTER //
// src/views/storeRegister/baseInfoRegister.vue